import React, { ReactElement } from 'react'

import Transactions from '../components/Transactions/Transactions'
import Overview from './../containers/Home/Account/Overview/Overview'
import PaymentInformation from './../containers/Home/Account/PaymentInformation/PaymentInformation'
import { Terms } from './../containers/Home/Account/Terms/Terms'
import Contact from './../containers/Home/CustomerService/Contact/Contact'
import ShowPin from './../containers/Home/Cardservice/ShowPin/ShowPin'
import MyAccountNo from '../containers/Home/Account/MyAccountNo/MyAccountNo'
import MyAccount from '../containers/Home/Account/MyAccount/MyAccount'
import Faq from '../containers/Home/CustomerService/FrequentlyAskedQuestions/Faq'
import AnnualReport from './../containers/Home/Account/AnnualReport/AnnualReport'
import ActivateLockCard from '../containers/Home/Cardservice/ActivateLockCard/ActivateLockCard'
import ChangeCreditLimit from '../containers/Home/Cardservice/ChangeCreditLimit/ChangeCreditLimit'
import WithdrawalNo from '../containers/Home/Account/Withdrawal/WithdrawalNo'
import ReferFriends from '../containers/Home/Account/ReferFriends/ReferFriends'
import SepaDirectDebit from '../containers/Home/Account/SDD/sepaDirectDebit'
import SetPasswordIdCheck from '../containers/Home/Cardservice/SetPasswordIdCheck'

import { ProductType } from '../interfaces/i-api-support'
import appConfig from 'app.config'
import WithdrawalDe from 'selfServicePortal/containers/Home/Account/Withdrawal/WithdrawalDe/WithdrawalDe'
import { PpiDe } from 'selfServicePortal/containers/Home/Cardservice/PpiDe'
// import ClickToPay from 'selfServicePortal/containers/Home/Cardservice/ClickToPay/ClickToPay'
import { CashToAccount } from 'selfServicePortal/containers/Home/Account/CashToAccount/CashToAccount'
import MarketingConsent from 'selfServicePortal/containers/Home/Account/MarketingConsent/MarketingConsent'
// TODO: 61614 Disable Consumer controls until pilot completed
//import CardSettings from 'selfServicePortal/containers/Home/Cardservice/CardSettings/CardSettings'

export interface IMenuItems {
	title: string | ReactElement
	items: IMenuDropdownItem[]
	products: ProductType[]
}

export interface IMenuDropdownItem {
	title: string | ReactElement
	show: boolean
	component: JSX.Element
	countries: string[]
	products: ProductType[]
}

export const menuItems: IMenuItems[] = [
	{
		title: 'Account',
		products: [
			ProductType.Deposit,
			ProductType.Deposit_Fixed,
			ProductType.Card,
		],
		items: [
			{
				title: 'Overview',
				show: true,
				component: <Overview />,
				countries: ['no', 'de', 'at', 'es', 'it'],
				products: [
					ProductType.Deposit_Fixed,
					ProductType.Deposit,
					ProductType.Card,
				],
			},
			{
				title: 'PaymentInformation',
				show: false,
				component: <PaymentInformation />,
				countries: ['no', 'de', 'at', 'es', 'it'],
				products: [
					ProductType.Deposit_Fixed,
					ProductType.Deposit,
					ProductType.Card,
				],
			},
			{
				title: 'RecentTransactions',
				show: false,
				component: <Transactions />,
				countries: ['no', 'de', 'at', 'es', 'it'],
				products: [
					ProductType.Deposit_Fixed,
					ProductType.Deposit,
					ProductType.Card,
				],
			},
			{
				title: 'TermsOfContract',
				show: true,
				component: <Terms />,
				countries: ['no', 'de', 'at', 'es', 'it'],
				products: [
					ProductType.Deposit_Fixed,
					ProductType.Deposit,
					ProductType.Card,
				],
			},
			{
				title: 'MyAccount',
				show: false,
				component:
					appConfig.country !== 'no' ? (
						<MyAccount />
					) : (
						<MyAccountNo />
					),
				countries: ['no', 'de', 'at'],
				products: [
					ProductType.Deposit_Fixed,
					ProductType.Deposit,
					ProductType.Card,
				],
			},
			{
				title: 'MarketingConsent.title',
				show: false,
				component: <MarketingConsent />,
				countries: ['de', 'at', 'no', 'es', 'it'],
				products: [ProductType.Card],
			},
			{
				title: 'ReferFriends',
				show: false,
				component: <ReferFriends />,
				countries: ['de', 'at'],
				products: [ProductType.Card],
			},
			{
				title: 'SDD',
				show: false,
				component: <SepaDirectDebit />,
				countries: [],
				products: [ProductType.Card],
			},
			{
				title: 'AnnualReport',
				show: false,
				component: <AnnualReport />,
				countries: ['no'],
				products: [
					ProductType.Deposit_Fixed,
					ProductType.Deposit,
					ProductType.Card,
				],
			},
			{
				title: 'Withdrawal',
				show: false,
				component: <WithdrawalNo />,
				countries: ['no'],
				products: [ProductType.Deposit],
			},
			{
				title: 'Withdrawal',
				show: false,
				component: <WithdrawalDe />,
				countries: ['de'],
				products: [ProductType.Deposit],
			},
		],
	},
	{
		title: 'CardServices',
		products: [ProductType.Card],
		items: [
			{
				title: 'ShowPIN',
				show: false,
				component: <ShowPin />,
				countries: ['no', 'de', 'at', 'es', 'it'],
				products: [ProductType.Card],
			},
			{
				title: 'SetPasswordMastercard',
				show: false,
				component: <SetPasswordIdCheck />,
				countries: ['de', 'at', 'es', 'it'],
				products: [ProductType.Card],
			},
			{
				title: 'ActivateLockCard',
				show: false,
				component: <ActivateLockCard />,
				countries: ['no'],
				products: [ProductType.Card],
			},
			{
				title: 'ChangeCreditLimit',
				show: false,
				component: <ChangeCreditLimit />,
				countries: ['no'],
				products: [ProductType.Card],
			},
			{
				title: 'ppi',
				show: false,
				component: <PpiDe />,
				countries: ['de'],
				products: [ProductType.Card],
			},
			// {
			//In order for this menuItem not to be shown for disabled markets
			//title needs to stay like this and link should be rendered through component
			// 	title: 'Click to Pay',
			// 	show: false,
			// 	component: <ClickToPay />,
			// 	countries: ['de', 'at', 'no'],
			// 	products: [ProductType.Card],
			// },
			{
				title: 'CashToAccount',
				show: false,
				component: <CashToAccount />,
				countries: ['de', 'at', 'no'],
				products: [ProductType.Card],
			},
			// TODO: 61614 Disable Consumer controls until pilot completed
			//{
			//	title: 'CardSettings',
			//	show: true,
			//	component: <CardSettings />,
			//	countries: ['no', 'de', 'at', 'es', 'it'],
			//	products: [ProductType.Card],
			//},
		],
	},
	{
		title: 'CustomerService',
		products: [
			ProductType.Deposit_Fixed,
			ProductType.Deposit,
			ProductType.Card,
		],
		items: [
			{
				title: 'FAQ/Q&A',
				show: false,
				component: <Faq />,
				countries: ['de', 'at', 'no'],
				products: [
					ProductType.Deposit_Fixed,
					ProductType.Deposit,
					ProductType.Card,
				],
			},
			{
				title: 'Contact',
				show: false,
				component: <Contact />,
				countries: ['no', 'de', 'at', 'es', 'it'],
				products: [
					ProductType.Deposit_Fixed,
					ProductType.Deposit,
					ProductType.Card,
				],
			},
		],
	},
]
